import {
  List,
  Box,
  Heading,
  Center,
  HStack,
  Text,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";

const TOC = () => {
  const { mailingList } = useSelector(
    (state) => state.defaultReducer
  );
  const { toc } = mailingList || {};

  if (!toc || !Array.isArray(toc) || toc.length === 0) {
    return (
      <Box className="toc-page">
        <Center>
          <Heading
            as="h1"
            fontSize="22pt"
            fontWeight="700"
            lineHeight="1.15"
            color="#111827"
            mb={0}
          >
            Table of Contents
          </Heading>
        </Center>
        <Box mt={10}>
          <Text>No table of contents data available</Text>
        </Box>
      </Box>
    );
  }

  return (
    <Box className="toc-page">
      <Center>
        <Heading
          as="h1"
          fontSize="22pt"
          fontWeight="700"
          lineHeight="1.15"
          color="#111827"
          mb={0}
        >
          Table of Contents
        </Heading>
      </Center>
      <Box mt="12mm">
        <List.Root gap={1.5} listStyleType="none" ps={0}>
          {toc.map(({ title, pageStart, index: reportIndex }, index) => (
            <List.Item key={index} listStyleType="none">
              <HStack width="100%" align="baseline" gap={2}>
                <Text
                  fontSize={reportIndex != null ? "11pt" : "10pt"}
                  lineHeight={reportIndex != null ? "1.35" : "1.3"}
                  whiteSpace="normal"
                  fontWeight={reportIndex != null ? "700" : "400"}
                  color="#1f2937"
                  mb={0}
                  overflowWrap="anywhere"
                  maxWidth={reportIndex != null ? "74%" : "78%"}
                  flex="0 1 auto"
                >
                  {title}
                </Text>
                {pageStart && (
                  <>
                    <Box
                      as="span"
                      flex="1 0 14mm"
                      borderBottom="1px dashed #9ca3af"
                      transform="translateY(-2px)"
                    >
                    </Box>
                    <Text
                      fontSize="10pt"
                      lineHeight="1.3"
                      color="#374151"
                      mb={0}
                      whiteSpace="nowrap"
                      minWidth="50px"
                      textAlign="right"
                      flexShrink={0}
                    >
                      Page {pageStart}
                    </Text>
                  </>
                )}
              </HStack>
            </List.Item>
          ))}
        </List.Root>
      </Box>
    </Box>
  );
};

export default TOC;
